import React, { useState } from 'react';

interface LinkDialogProps {
  initialUrl?: string;
  onInsert: (url: string, text?: string) => void;
  onRemove?: () => void;
  onClose: () => void;
}

export const LinkDialog: React.FC<LinkDialogProps> = ({
  initialUrl = '',
  onInsert,
  onRemove,
  onClose,
}) => {
  const [url, setUrl] = useState(initialUrl);
  const [text, setText] = useState('');

  const handleInsert = () => {
    if (!url.trim()) return;
    onInsert(url.trim(), text.trim() || undefined);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-sm p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-gray-900">
            {initialUrl ? 'Edit Link' : 'Insert Link'}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-xl"
          >
            ×
          </button>
        </div>

        <div className="space-y-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              URL *
            </label>
            <input
              type="url"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleInsert();
              }}
              placeholder="https://example.com"
              autoFocus
              className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {!initialUrl && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Link Text (optional)
              </label>
              <input
                type="text"
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Displayed text"
                className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          )}
        </div>

        <div className="flex gap-3 mt-5 justify-between">
          <div>
            {onRemove && initialUrl && (
              <button
                onClick={onRemove}
                className="px-4 py-2 text-sm text-red-600 border border-red-300 rounded hover:bg-red-50"
              >
                Remove Link
              </button>
            )}
          </div>
          <div className="flex gap-2">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm text-gray-700 border border-gray-300 rounded hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              onClick={handleInsert}
              disabled={!url.trim()}
              className="px-4 py-2 text-sm text-white bg-blue-600 rounded hover:bg-blue-700 disabled:opacity-50"
            >
              {initialUrl ? 'Update' : 'Insert'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
